import type { Discount } from '../../domain/types'
import type { DiscountsAPIResponse } from '../types'

export function mapDiscount(apiResponse: DiscountsAPIResponse | null): Discount | null {
  const discounts = apiResponse?.data?.discounts
  if (!discounts) {
    return null
  }

  const validDiscount = discounts
    .find(discount => discount.status === 'Active' && discount.canBeUsed === true)

  if (!validDiscount) {
    return null
  }

  return {
    discountAmount: validDiscount.discountAmount,
  }
}
